export default "__VITE_ASSET__COb7PD7p__"